<div *ngIf="isLoading | async" class="overlay">
  <mat-progress-spinner diameter="60" strokeWidth="3" class="spinner" mode="indeterminate">
  </mat-progress-spinner>
</div>
